module.exports = __webpack_public_path__ + "static/media/noData_1.c99b6414.png";